import { Input, Output, Component, OnInit, EventEmitter } from '@angular/core';

@Component({
  selector: 'ness-info-reports-notes',
  templateUrl: './info-reports-notes.component.html'
})
export class InfoReportsNotesComponent {
  @Input() infoReportNotes: string;
  @Output() showInfoReportNotes: EventEmitter<boolean> = new EventEmitter<boolean>();

}
